<template>
  <header>
    <div class="page-container flex flex-justify global-header">
      <!-- <a
        href="javascript:;"
        class="menu-btn flex flex-jcenter flex-acenter"
        @click="showDrawer"
      >
        <span class="iconfont iconmenu cfff ft34"></span>
      </a> -->
      <div class="flex flex-justify flex-1 plr25">
        <div class="flex flex-jcenter flex-acenter">
          <logo />
          <span class="action ant-dropdown-link user-dropdown-menu" style="margin-left: 30px">
            <!-- <a-avatar class="avatar" size="small" :src="avatar"/> -->
            <span class="ml5">
              {{ $t('HistoricalRedemptionRecords.Welcome') }}
              <a class="cmain">
                {{
                  lang == 'zh'
                  ? userInfo.CAName
                  : userInfo.CANameEn || userInfo.CAName
                }}</a>
            </span>
          </span>
        </div>
        <div class="flex flex-acenter flex-jcenter">
          <Language></Language>
          <div class="ml25">
            <!-- <a-dropdown> -->

            <!-- <el-divider direction="vertical"></el-divider> -->
            <el-popconfirm :title="$t('UserInterface.LoginOut')" @confirm="handleLogoutClick()">
              <i slot="reference" class="el-icon-switch-button"
                style="color: black; font-size: 20px; cursor: pointer"></i>
            </el-popconfirm>

            <!-- <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
                <a-menu-item key="3">

                </a-menu-item>
              </a-menu> -->
            <!-- </a-dropdown> -->
          </div>
        </div>
      </div>
    </div>
    <a-drawer :placement="placement" :closable="false" :visible="visible" class="menu-nav" :width="collapsed ? 70 : 200"
      :mask="false" getContainer="header" @close="onClose">
      <menu-nav class="mt20" :collapsed="collapsed" @menuClick="collapsed = false" />
    </a-drawer>
    <!-- <div class="nav-menu">

    </div> -->
  </header>
</template>
<script>
import logo from '@/components/Logo/Logo.vue';
import { mapGetters, mapActions } from 'vuex';
import MenuNav from '@/components/Menu/Menu.vue';
import Language from '@/components/Language/index.vue'
import { USER_INFO, ACCESS_TOKEN } from '@/store/mutation-types';
import { timeFix } from '@/utils/util';
import ipConfig from '../../../config/ip.config';
import Cookies from 'js-cookie';
export default {
  components: { logo, MenuNav, Language },
  computed: {
    ...mapGetters(['nickname', 'avatar']),
    showBack() {
      const url = this.$route.name;
      console.log(this.$route);
      return url === 'productDetail';
    },
  },
  data() {
    return {
      visible: true,
      placement: 'left',
      collapsed: false,
      timeFix: timeFix(),
      userInfo: {},
      token: '',
      lang: 'zh'
    };
  },
  created() {
    // const userInfo = JSON.parse(Cookies.get('MW_USERCENTER_INFO') || '{"CACode":"201808014924","CAName":"大金化学国际贸易（上海）有限公司","CANameEn":"Daikin Chemical International Trading (Shanghai) Co., Ltd.","CAEmail":"ding.lin@daikin.net.cn","MenuList":["Dashboard","Tracking","OceanFreight","AirFreight","RailwayFreight","Trucking","Warehousing","TankService","Invoice","Agreement"]}');
    // const token = Cookies.get('MW_USERCENTER_TOKEN') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyMDE4MDgwMTQ5MjQiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoi5aSn6YeR5YyW5a2m5Zu96ZmF6LS45piT77yI5LiK5rW377yJ5pyJ6ZmQ5YWs5Y-4IiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbW9iaWxlcGhvbmUiOiIiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9lbWFpbGFkZHJlc3MiOiJkaW5nLmxpbkBkYWlraW4ubmV0LmNuIiwiaWF0IjoiMTc1NDQ0NjUyMyIsIm5iZiI6IjE3NTQ0NDY1MjMiLCJleHAiOiIxNzU0NTMyOTIzIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9leHBpcmF0aW9uIjoiMjAyNS84LzcgMTA6MTU6MjMiLCJpc3MiOiJtd2NsZ0N1c3RvbWVyQWNjb3VudFNlbGVjdCIsImF1ZCI6ImFwaWdldFRva2VuIn0.zdMSNPEKxkNMS1w5piYP1sTBKWagAkep3dCVjdv9XL8'
    const userInfo = JSON.parse(Cookies.get('MW_USERCENTER_INFO') || '{}');
    const token = Cookies.get('MW_USERCENTER_TOKEN') || ''
    this.$ls.set(USER_INFO, userInfo || {});
    this.$ls.set(ACCESS_TOKEN, token);
    this.userInfo = userInfo || {};
    console.log('userInfo，', this.userInfo)
    this.token = token;
    if (!this.token) {
      console.log('跳转官网');
      window.location.href = ipConfig.LOGINURL;
    }
    this.lang = this.$ls.get('lang') || 'zh';
  },
  methods: {
    ...mapActions('user', ['logout']),
    goToMall() {
      console.log('跳转');
      this.$router.push({
        name: 'pointsMall',
      });
    },
    showDrawer() {
      // this.collapsed = !this.collapsed
    },
    onClose() {
      this.collapsed = true;
    },
    handleLogoutClick() {
      this.logout();
    },
  },
};
</script>
<style lang="less">
.global-header {
  .el-divider--vertical {
    margin: 0 12px;
  }

  .back-wrap {
    color: #51abc3;
    cursor: pointer;
    margin-left: 15px;
  }
}

.menu-nav .ant-drawer-body {
  padding: 0;
}
</style>
<style lang="less" scoped>
@import '../../styles/var.less';

header {
  position: fixed;
  width: 100%;
  z-index: 9;
  background-color: @white;
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.1);

  .page-container {
    height: 40px;
  }
}

.menu-btn {
  //position: absolute;
  width: 70px;
  height: 100%;
  background-color: @main-color;
  //left: 0;
}

.ant-drawer-left {
  top: 40px;
  height: calc(100vh - 40px);
}

::v-deep .ant-drawer-wrapper-body {
  overflow-x: hidden;
}

.ant-input-affix-wrapper {
  width: 280px;
}

.ant-input {
  border-radius: 18px;
  background-color: #d7d7d7;
}

// .ant-menu{
//   margin-left: 130px;
//   background-color: @main-color;
//   // height: 70px;
//   .ant-menu-submenu,.ant-menu-item{
//     height: 70px;
//     line-height: 70px;
//     border-bottom: none;
//   }
//   .ant-menu-submenu-active,.ant-menu-item-active{
//     color: #fff;
//     border-bottom: none;
//   }
//   .ant-menu-submenu-selected,.ant-menu-item-selected{
//     position: relative;
//     background-color: @dark-main-color;
//     &::before{
//       position: absolute;
//       content: "";
//       width: 100%;
//       height: 4px;
//       top: -1px;
//       background-color: #D1F9FF;
//     }
//   }
//   .ant-menu-horizontal{
//     border-bottom: none;
//   }
// }
</style>
